// Which intake-form field titles trigger the PDOK address lookup on blur.
//
// Single source of truth so the trigger survives a field's Type changing:
// Huisnummer renders as a number input, Postcode and Straatnaam as text, and
// both branches must arm the same lookup. Toevoeging is in it because in a
// building with 12A and 12B it picks the unit (and so the BAG-id). Woonplaats
// is deliberately absent — the lookup writes into it, so typing there must not
// re-query.
const ADDRESS_LOOKUP_TITLES = ["postcode", "huisnummer", "toevoeging", "straatnaam"];

/**
 * @param {string} title - De vraagtitel
 * @param {string} [fixedFieldKey] - Het vaste gegeven waaraan de vraag hangt (T13)
 * @returns {boolean}
 */
const isAddressLookupField = (title, fixedFieldKey) =>
    ADDRESS_LOOKUP_TITLES.includes(String(fixedFieldKey || title || "").trim().toLowerCase());

export default isAddressLookupField;
